import styled from '@emotion/styled';
import { tokens, Modal, Loader, Text } from '@hotjar/hotsauce';

export const ModalStyles = {
  Modal: styled(Modal)`
    background: ${tokens.BRAND_COLORS.cobalt_100};
    margin: ${tokens.spacer.x6} auto;
    max-height: calc(100vh - ${tokens.spacer.x6} * 2);
    overflow: hidden;
    width: 1136px;
  `,
  ModalHeader: styled(Modal.Header)`
    background: ${tokens.color.white};
    border-bottom: 1px solid ${tokens.color.ui_border_light};
  `,
  ModalBody: styled(Modal.Body)`
    padding-top: ${tokens.spacer.x3};
  `,
  ModalFooter: styled(Modal.Footer)`
    align-items: center;
    border-top: 1px solid ${tokens.color.ui_border};
    justify-content: flex-start;
    margin: 0 ${tokens.spacer.x1pt5};
    padding: ${tokens.spacer.x2} ${tokens.spacer.x1pt5} ${tokens.spacer.x3};
  `,
  Loader: styled(Loader)`
    flex: 1 1 auto;
  `,
  BundleDiscount: styled(Text)`
    margin-left: ${tokens.spacer.x1};
  `,
  PlanComparisonColumnsHeader: styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-left: ${tokens.spacer.x1pt5};
    margin-bottom: ${tokens.spacer.x2};
  `,
  PlanComparisonColumnsLabel: styled(Text)`
    display: inline-block;

    ${tokens.text('subtitle1')};
  `,
};

export const TrafficBarStyles = {
  Container: styled.div<{ hasDivider: boolean }>`
    align-items: stretch;
    border-bottom: ${(props) => (props.hasDivider ? `1px solid ${tokens.color.ui_border}` : `0`)};
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: ${(props) => (props.hasDivider ? `${tokens.spacer.x2}` : `${tokens.spacer.x3}`)};
    padding: ${(props) => (props.hasDivider ? `0 0 ${tokens.spacer.x3}` : `0`)};
  `,
  TextWrapper: styled.div`
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    flex: 1;
    justify-content: center;
    max-width: 40%;
  `,
  TrafficCoverageWrapper: styled.div`
    background: ${tokens.color.white};
    border-radius: ${tokens.radius.m};
    border: 1px solid ${tokens.color.ui_border};
    flex: 1;
    max-width: 40%;
  `,
  Title: styled.span`
    display: block;
    margin-bottom: ${tokens.spacer.x1};

    ${tokens.text('subtitle1')};
  `,
  Description: styled.span`
    color: ${tokens.color.text_light};
    display: block;

    ${tokens.text('body1')};
  `,
};
